/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TaskInfo,
    TaskInfoFromJSON,
    TaskInfoFromJSONTyped,
    TaskInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface AIDatasetExportResponse
 */
export interface AIDatasetExportResponse {
    /**
     * 
     * @type {TaskInfo}
     * @memberof AIDatasetExportResponse
     */
    task: TaskInfo;
}

export function AIDatasetExportResponseFromJSON(json: any): AIDatasetExportResponse {
    return AIDatasetExportResponseFromJSONTyped(json, false);
}

export function AIDatasetExportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIDatasetExportResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'task': TaskInfoFromJSON(json['task']),
    };
}

export function AIDatasetExportResponseToJSON(value?: AIDatasetExportResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'task': TaskInfoToJSON(value.task),
    };
}


